module.exports = __webpack_public_path__ + "static/media/tick-circle.19171b6c.svg";